import { useRef } from 'react';

import { Stack } from '@chakra-ui/react';
import { Sheet } from 'react-modal-sheet';

import { ReactComponent as ArrowLeftIcon } from '../../icons/arrow.left.svg';
import { ReactComponent as CloseIcon } from '../../icons/xmark.svg';
import MyPhotoCardBoardContent, { useMyPhotoCardBoard } from '../../presentation/binder/components/MyPhotoCardBoardContent';

export default function MyPhotoCardBottomSheet({
  members,
  isMyPhotoCardsBottomSheetOpen,
  setIsMyPhotoCardsBottomSheetOpen
}) {
  const ref = useRef();
  const board = useMyPhotoCardBoard({
    members,
    isActive: isMyPhotoCardsBottomSheetOpen,
    onClose: () => setIsMyPhotoCardsBottomSheetOpen(false),
    surface: 'bottomSheet'
  });

  return (
    <Sheet
      ref={ref}
      isOpen={isMyPhotoCardsBottomSheetOpen}
      disableDrag={true}
      onClose={() => board.closeBoard()}
    >
      <Sheet.Container
        className="!bg-backgroundElevated-light dark:!bg-backgroundElevated-dark"
        style={{
          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px',
          paddingBottom: 'calc(2rem + env(safe-area-inset-bottom))'
        }}
      >
        <Sheet.Header className="bottomSheetHeader">
          <div id="bottomSheetHeader">
            <Stack>
              {board.isSaveImage
                ? <ArrowLeftIcon
                    className="fill-black dark:fill-white"
                    onClick={() => board.exitSaveImage()}
                  />
                : <CloseIcon
                    className="fill-black dark:fill-white"
                    onClick={() => board.closeBoard()}
                  />}
            </Stack>
          </div>
        </Sheet.Header>
        <Sheet.Content disableDrag={true} className="bottomSheetContent">
          <MyPhotoCardBoardContent
            board={board}
            bottomButtonStyle={{
              width: 'calc(100% - 45px)',
              marginBottom: 'calc(40px + env(safe-area-inset-bottom))'
            }}
          />
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onClick={() => board.closeBoard()} />
    </Sheet>
  );
}
